import React from 'react';
import { Button } from '../ui/button';
import './page-design.css';

// Button groups preserve existing navigation/filter behavior. These deliberately
// do not claim ARIA tab roles without the corresponding keyboard/tab-panel model.
export function PageTabs({ children, className = '', label = 'Sidvyer' }) {
  return (
    <div className={`tn-page-tabs ${className}`} role="group" aria-label={label}>
      {children}
    </div>
  );
}

export const PageTab = React.forwardRef(function PageTab(
  { active = false, children, className = '', ...props }, ref,
) {
  return (
    <Button
      {...props}
      ref={ref}
      type="button"
      variant="ghost"
      size="sm"
      className={`tn-page-tab ${className}`}
      aria-pressed={active}
    >
      {children}
    </Button>
  );
});
